"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureToggles = getFeatureToggles;
var _axios = require("@ori/axios");
/** @deprecated Use the `getFeatureToggles` function from the `@ori/feature-toggles` library */
async function getFeatureToggles(onlineUrl, tenant, token) {
  const url = `${onlineUrl}/api/v2/featureToggles`;
  const response = await _axios.axios.get(url, {
    headers: {
      'x-tenant-context': tenant,
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.Collection;
}
